import {
  FaUser,
  FaCreditCard,
  FaImages,
  FaBell,
  FaMapMarkedAlt,
} from 'react-icons/fa';

/** Enamel hub tabs — order matches prototype Profile Hub. */
export const PROFILE_HUB_TABS = [
  { id: 'profile', label: 'MY PROFILE', path: '/profile', icon: FaUser },
  { id: 'notifications', label: 'NOTIFICATIONS', path: '/notifications', icon: FaBell },
  { id: 'account', label: 'ACCOUNT', path: '/profile/account', icon: FaCreditCard },
  { id: 'my-stuff', label: 'MY STUFF', path: '/profile/my-stuff', icon: FaImages },
];

/** @deprecated use PROFILE_HUB_TABS — kept for older imports */
export const PROFILE_SHELL_TABS = PROFILE_HUB_TABS.filter((t) => t.id !== 'notifications');

export const MY_STUFF_TABS = [
  { id: 'photos', label: 'Photos', icon: FaImages },
  { id: 'parcels', label: 'Parcel Requests', icon: FaMapMarkedAlt },
];

export function getProfileSection(pathname) {
  if (pathname === '/notifications' || pathname.startsWith('/notifications/')) {
    return 'notifications';
  }
  if (pathname === '/profile/account') return 'account';
  if (pathname === '/profile/my-stuff') return 'my-stuff';
  return 'profile';
}

export function getProfileTabPath(tabId) {
  const tab = PROFILE_HUB_TABS.find((t) => t.id === tabId);
  return tab?.path || '/profile';
}

/** True when the field-edition Profile Hub owns the screen (hide app chrome title bar). */
export function isProfileHubPath(pathname = '') {
  const path = pathname || '';
  if (path === '/notifications' || path.startsWith('/notifications/')) return true;
  if (path === '/profile' || path.startsWith('/profile/')) return true;
  return false;
}
